var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-wrap"},[_c('swiper',{staticClass:"swiper",attrs:{"options":_vm.swiperOption}},[_c('swiper-slide',[_vm._v("1")]),_c('swiper-slide',[_vm._v("2")]),_c('swiper-slide',[_vm._v("3")]),_c('swiper-slide',[_vm._v("4")]),_c('swiper-slide',[_vm._v("5")]),_c('swiper-slide',[_vm._v("6")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }